module.exports = __webpack_public_path__ + "img/background-home.2e8c4bae.jpg";